<template>
  <div class="app flex-row align-items-center">
    <b-modal title="Erro!" class="modal-danger" v-model="hasErrors" @ok="hasErrors = false" ok-variant="danger" ok-only>
      Usuário ou senha inválidos
    </b-modal>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Login</h1>
                <p class="text-muted">Entre com sua conta</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input type="text" class="form-control" placeholder="Matrícula" 
                    v-model="user.registration">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input type="password" class="form-control" placeholder="Senha" 
                    v-model="user.password">
                </div>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" class="px-4" @click="login">Entrar</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      user: {
        registration: '',
        password: ''
      },
      loading: false,
      hasErrors: false
    }
  },
  mounted () {
    if (this.$store.state.user !== null || window.localStorage.getItem('origami_admin_user') !== 'null') {
      this.$router.push({name: 'Dashboard'})
    }
  },
  methods: {
    login () {
      this.$http.post(`auth/login`, this.user)
        .then(response => {
          this.$store.commit('setUser', response.data.user)
          this.$store.commit('setToken', response.data.token)
          if (window.localStorage) {
            window.localStorage.setItem('origami_admin_user', JSON.stringify(response.data.user))
            window.localStorage.setItem('origami_admin_token', response.data.token)
          }
          this.$http.defaults.headers.Authorization = `Bearer ${window.localStorage.getItem('origami_admin_token')}`
          this.hasErrors = false
          this.$router.push({name: 'Dashboard'})
        })
        .catch(e => {
          this.loading = false
          this.hasErrors = true
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/pages/Login.vue